import { useEffect, useState } from "react";
import { Oval } from "react-loader-spinner";
import { formatUSPhone } from "src/Common/function";
import UserService from "src/Services/API/user.service";
function AdminAddModal({ customer, selectedAccount, onAddClicked, onCancelClicked }) {
  const currentUser = UserService.getCurrentUser();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isInviting, setIsInviting] = useState(false);

  // useEffect(() => {
  //   setName(customer.name);
  //   setEmail(customer.email);
  //   setPhone(customer.phone);
  // }, []);

  const addClicked = async () => {
    if (isInviting) return;
    const data = {
      name,
      email: email.trim().toLowerCase(),
      phone,
      accountId: selectedAccount?.id,
      customerId: customer?.id,
      invitedById: currentUser.id,
      company: currentUser.company,
    };
    setIsInviting(true);
    try {
      await onAddClicked(data);
    } finally {
      setIsInviting(false);
    }
  };

  const cancelClicked = () => {
    if (isInviting) return;
    onCancelClicked();
  };

  return (
    <div
      onClick={cancelClicked}
      className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[448px] h-[322px] bg-white rounded-[6px] p-[18px] flex flex-col"
      >
        <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-5">ADD CUSTOMER ADMIN</p>

        <div className="flex flex-col justify-between h-full">
          <div className="h-[60px] w-full">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Name</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
              <input
                value={name}
                type="text"
                onChange={(e) => setName(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Enter name"
              />
            </div>
          </div>

          <div className="h-[60px] w-full">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Email</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
              <input
                value={email}
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="Enter email"
              />
            </div>
          </div>

          <div className="h-[60px] w-full">
            <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Phone Number</p>
            <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
              <input
                value={phone}
                type="text"
                onChange={(e) => setPhone(formatUSPhone(e.target.value))}
                className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                placeholder="(xxx) xxx-xxxx"
              />
            </div>
          </div>

          <div className=" w-full">
            <div className="flex items-center justify-between gap-4">
              <div
                onClick={cancelClicked}
                className={`w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor ${
                  isInviting ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
                }`}
              >
                CANCEL
              </div>
              <div
                onClick={addClicked}
                className={`w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white ${
                  isInviting ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
                }`}
              >
                {isInviting ? (
                  <Oval
                    visible={true}
                    height="14"
                    width="14"
                    color="#FFFFFF"
                    strokeWidth={8}
                    secondaryColor="#FFEEFF"
                    ariaLabel="invite-loading"
                  />
                ) : (
                  "Send Invite"
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminAddModal;
